// Suppress Locize support notice from third-party dependencies
// https://www.locize.com/docs/general-questions/why-am-i-seeing-a-support-notice-for-i18next/#2-global-suppression-for-third-party-dependencies
globalThis.__i18next_supportNoticeShown = true;
